// import React, { useState, useCallback, useEffect, useMemo } from "react";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
// import { ReactComponent as DeleteIcon } from "../../../../assets/svgs/delete.svg";
// import { locationSample } from "../../../../utils/schema/locationSample";
// import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
// import { useNavigate } from "react-router-dom";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import CreateLocation from "./DIalogBoxes/CreateLocation";
// import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
// import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
// import SortData from "../../../../components/Elements/SortData.js/SortData";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { getApi, putApi, deleteApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import EditLocation from "./DIalogBoxes/EditLocation";
// import { message } from "antd";
// import { THEME_COLORS } from "../../../../color";

// const LocationUser = () => {
//   const navigate = useNavigate();
//   const [openCreateDialog, setOpenCreateDialog] = useState(false);

//   const initialStatusData = locationSample.map((item) => ({
//     ...item,
//     status: true,
//   }));

//   const [locations, setLocations] = useState(initialStatusData);
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [openEditDialog, setOpenEditDialog] = useState(false);
//   const [selectedlocation, setSelectedLocation] = useState(null);
//   const [pageNo, setPageNo] = useState(1);
//   const [total, setTotal] = useState(0);
//   const pageSize = 10;
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(false);

//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Location Name", key: "location" },
//     { label: "Description", key: "description" },
//     { label: "Action", key: "action" },
//   ];
//   const fetchLocations = useCallback(
//     async (page = 1) => {
//       try {
//         setLoading(true);
//         const response = await getApi({
//           apiUrl: API_URLS.ALL_LOCATIONUSERS(page, pageSize, searchTerm),
//         });

//         if (response.data.data) {
//           const locationData = response.data.data.map((item, index) => ({
//             key: item._id,
//             serial: (page - 1) * pageSize + (index + 1),
//             location: item.location_name,
//             description: item.description,
//             action: (
//               <div className="flex gap-4 items-center">
//                 <EditIcon
//                   style={{ marginRight: 10, cursor: "pointer" }}
//                   onClick={() => {
//                     setSelectedLocation(item);
//                     setOpenEditDialog(true);
//                   }}
//                 />
//                 <DeleteIcon
//                   style={{ cursor: "pointer" }}
//                   onClick={() => handleDeleteLocation(item._id)}
//                 />
//                 <CustomSwitch
//                   checked={item.status === "Active"}
//                   onChange={() => handleToggleStatus(item._id, item.status)}
//                 />
//               </div>
//             ),
//           }));

//           setLocations(locationData);

//           setTotal(response.data.metadata?.total || locationData.length);
//         } else {
//           setLocations([]);
//           setTotal(0);
//         }
//       } catch (error) {
//         console.error("Error fetching locations:", error);
//         setLocations([]);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [searchTerm],
//   );

//   useEffect(() => {
//     fetchLocations(pageNo);
//   }, [fetchLocations, pageNo]);

//   const handleSort = (key, order) => {
//     setSortBy(key);
//     setSortOrder(order);
//   };
//   const handleDeleteLocation = async (id) => {
//     try {
//       setLoading(true);
//       const res = await deleteApi({ apiUrl: API_URLS.DELETE_LOCATION(id) });

//       if (res?.success) {
//         message.success({
//           content: "Location deleted successfully!",
//           duration: 2,
//         });
//         fetchLocations();
//       } else {
//         message.error({
//           content: res?.message || "Failed to delete Location.",
//           duration: 2,
//         });
//       }
//     } catch (error) {
//       console.error("Delete error:", error);
//       message.error({
//         content: "An unexpected error occurred while deleting the role.",
//         duration: 2,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleToggleStatus = async (locationId, currentStatus) => {
//     try {
//       const newStatus = currentStatus === "Active" ? "Deactive" : "Active";

//       await putApi({
//         apiUrl: API_URLS.EDIT_LOCATIONUSER(locationId),
//         data: { status: newStatus },
//       });
//       fetchLocations(pageNo);
//     } catch (error) {
//       console.error("Error updating user status:", error);
//     }
//   };
//   const sortedData = useMemo(() => {
//     let data = [...locations];
//     if (sortBy && sortOrder) {
//       data = SortData({ data, key: sortBy, order: sortOrder });
//     }
//     return data;
//   }, [locations, sortBy, sortOrder]);

//   return (
//     <div style={{ backgroundColor: "#fff" }} className="h-full px-5 pb-5 ">
//       <div>
//         <div className="flex justify-end text-xs font-light p-3">
//           <p>Home</p>
//           <span>/</span> <p>User Management</p>
//           <span>/</span>
//           <TextStyles style={{ color: THEME_COLORS.green }}>
//             Location User
//           </TextStyles>
//         </div>
//         <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold">
//           <Back onClick={() => navigate(-1)} className="cursor-pointer" />
//           <div>Location User</div>
//         </div>
//         <div
//           style={{
//             border: "1px solid #ebedf3",
//             borderRadius: "10px",
//             paddingTop: "20px",
//           }}
//         >
//           <div className="flex justify-between px-3 mb-3">
//             <div className="flex gap-4 pl-9">
//               <div className="px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-base font-light">
//                 TOTAL LOCATION {locations.length}
//               </div>
//               <SearchBar width="300px" onSearch={setSearchTerm} />
//             </div>
//             <div className="flex gap-4">
//               <CustomButton
//                 buttonType="button"
//                 variant="ok"
//                 buttonText="Add New"
//                 onClick={() => setOpenCreateDialog(true)}
//                 className="text-base font-normal h-[50px] w-[160px]"
//               />
//             </div>
//           </div>

//           <Tables
//             data={sortedData}
//             headers={headers}
//             pageSize={pageSize}
//             current={pageNo}
//             total={total}
//             loading={loading}
//             onChange={(page) => setPageNo(page)}
//             sortBy={sortBy}
//             sortOrder={sortOrder}
//             onSort={handleSort}
//           />
//         </div>

//         {openCreateDialog && (
//           <CreateLocation
//             onOpen={openCreateDialog}
//             onClose={() => setOpenCreateDialog(false)}
//             onSuccess={() => {
//               fetchLocations(pageNo);
//               setOpenCreateDialog(false);
//             }}
//           />
//         )}
//         {openEditDialog && selectedlocation && (
//           <EditLocation
//             onOpen={openEditDialog}
//             onClose={() => setOpenEditDialog(false)}
//             locationData={selectedlocation}
//             onUpdate={fetchLocations}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default LocationUser;

import React, { useState, useCallback, useEffect, useMemo } from "react";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/svgs/delete.svg";
import { locationSample } from "../../../../utils/schema/locationSample";
import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
import { useNavigate } from "react-router-dom";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import CreateLocation from "./DIalogBoxes/CreateLocation";
import CustomSwitch from "../../../../components/Elements/CustomSwitch/CustomSwitch";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { getApi, putApi, deleteApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import EditLocation from "./DIalogBoxes/EditLocation";
import { message, Pagination } from "antd";
import { THEME_COLORS } from "../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";

const MobileCard = ({ item }) => (
  <div
    key={item.key}
    className="bg-white rounded-xl shadow-md border border-gray-200 p-4 mb-4"
    style={{
      background: "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
    }}
  >
    <div className="flex justify-between items-center mb-2">
      <span className="font-semibold text-gray-600">#</span>
      <span className="text-gray-800">{item.serial}</span>
    </div>

    <div className="flex justify-between items-center mb-2">
      <span className="font-semibold text-gray-600">Location</span>
      <span className="text-gray-800 text-right max-w-[60%]">
        {item.location}
      </span>
    </div>

    <div className="flex justify-between items-center mb-2">
      <span className="font-semibold text-gray-600">Description</span>
      <span className="text-gray-800 text-right max-w-[60%]">
        {" "}
        {item.description || "-"}
      </span>
    </div>

    {/* <div className="mb-2">
      <span className="font-semibold text-gray-600 block">Description</span>
      <p className="text-gray-800 text-sm mt-1 leading-snug break-words text-justify">
        {item.description || "-"}
      </p>
    </div> */}

    <div className="flex justify-between items-center mt-2">
      <span className="font-semibold text-gray-600">Action</span>
      <div className="flex gap-3">{item.action}</div>
    </div>
  </div>
);

const EmpLocationUsers = () => {
  const navigate = useNavigate();
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const initialStatusData = locationSample.map((item) => ({
    ...item,
    status: true,
  }));

  const [locations, setLocations] = useState(initialStatusData);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedlocation, setSelectedLocation] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Location Name", key: "location" },
    { label: "Description", key: "description" },
    { label: "Action", key: "action" },
  ];

  const fetchLocations = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await getApi({
          apiUrl: API_URLS.ALL_LOCATIONUSERS(page, pageSize, searchTerm),
        });

        if (response.data.data) {
          const locationData = response.data.data.map((item, index) => ({
            key: item._id,
            serial: (page - 1) * pageSize + (index + 1),
            location: item.location_name,
            description: item.description,
            action: (
              <div className="flex flex-wrap gap-3 items-center">
                <EditIcon
                  style={{ marginRight: 10, cursor: "pointer" }}
                  onClick={() => {
                    setSelectedLocation(item);
                    setOpenEditDialog(true);
                  }}
                />
                <DeleteIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDeleteLocation(item._id)}
                />
                <CustomSwitch
                  checked={item.status === "Active"}
                  onChange={() => handleToggleStatus(item._id, item.status)}
                />
              </div>
            ),
          }));

          setLocations(locationData);
          setTotal(response.data.metadata?.total || locationData.length);
        } else {
          setLocations([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        setLocations([]);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm],
  );

  useEffect(() => {
    fetchLocations(pageNo);
  }, [fetchLocations, pageNo]);

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
  };

  const handleDeleteLocation = async (id) => {
    try {
      setLoading(true);
      const res = await deleteApi({ apiUrl: API_URLS.DELETE_LOCATION(id) });

      if (res?.success) {
        message.success({
          content: "Location deleted successfully!",
          duration: 2,
        });
        fetchLocations();
      } else {
        message.error({
          content: res?.message || "Failed to delete Location.",
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Delete error:", error);
      message.error({
        content: "An unexpected error occurred while deleting the role.",
        duration: 2,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (locationId, currentStatus) => {
    try {
      const newStatus = currentStatus === "Active" ? "Deactive" : "Active";
      await putApi({
        apiUrl: API_URLS.EDIT_LOCATIONUSER(locationId),
        data: { status: newStatus },
      });
      fetchLocations(pageNo);
    } catch (error) {
      console.error("Error updating user status:", error);
    }
  };

  const sortedData = useMemo(() => {
    let data = [...locations];
    if (sortBy && sortOrder) {
      data = SortData({ data, key: sortBy, order: sortOrder });
    }
    return data;
  }, [locations, sortBy, sortOrder]);

  return (
    <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      <div className="">
        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <p>User Management</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}> Location User</TextStyles>
        </div>

        <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          <IoArrowBackCircleOutline
            onClick={() => navigate(-1)}
            className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
          />
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
            Location User
          </div>
        </div>

        <div className="border border-[#ebedf3] rounded-xl pt-5 bg-[#fff] ">
          <div className="flex flex-wrap justify-between items-center px-4 mb-4 gap-4">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 w-full sm:w-auto">
              <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
                TOTAL LOCATION {locations.length}
              </div>
              <SearchBar width="100%" onSearch={setSearchTerm} />
            </div>
            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Add New"
              onClick={() => setOpenCreateDialog(true)}
              className="text-sm sm:text-base font-normal h-[45px] sm:h-[50px] w-full sm:w-[160px]"
            />
          </div>

          {/* Desktop Table View */}
          <div className="hidden md:block overflow-x-auto">
            <Tables
              data={sortedData}
              headers={headers}
              pageSize={pageSize}
              current={pageNo}
              total={total}
              loading={loading}
              onChange={(page) => setPageNo(page)}
              sortBy={sortBy}
              sortOrder={sortOrder}
              onSort={handleSort}
            />
          </div>

          {/* Mobile Card View */}
          <div className="md:hidden px-4 pb-4">
            {loading ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">Loading...</div>
              </div>
            ) : sortedData.length === 0 ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">No locations found</div>
              </div>
            ) : (
              <>
                {sortedData.map((item) => (
                  <MobileCard key={item.key} item={item} />
                ))}

                {/* Mobile Pagination */}
                <div className="flex justify-center mt-4">
                  <Pagination
                    current={pageNo}
                    total={total}
                    pageSize={pageSize}
                    onChange={(page) => setPageNo(page)}
                    showSizeChanger={false}
                    size="small"
                    showQuickJumper={false}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {openCreateDialog && (
          <CreateLocation
            onOpen={openCreateDialog}
            onClose={() => setOpenCreateDialog(false)}
            onSuccess={() => {
              fetchLocations(pageNo);
              setOpenCreateDialog(false);
            }}
          />
        )}
        {openEditDialog && selectedlocation && (
          <EditLocation
            onOpen={openEditDialog}
            onClose={() => setOpenEditDialog(false)}
            locationData={selectedlocation}
            onUpdate={fetchLocations}
          />
        )}
      </div>
    </div>
  );
};

export default EmpLocationUsers;
